// extracted by css-extract-rspack-plugin
export default {"card":"YuWM3","selected":"w1CQO","handle":"JjqaW","initialized":"cQ2hE","pill":"FoXGs"};